import MDBox from "components/MDBox";
import React, { useState, useEffect } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Accordion, AccordionSummary, AccordionDetails, Icon, Select, MenuItem, InputLabel } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from "@mui/material/FormControl";
import { updateTrackingStatus, deleteTrackingHistory } from "network/service";
import moment from "moment";

let status_titles = {
    0: "Pending",
    5: "Package received",
    1: "Intransit",
    2: "On Hold",
    3: "Delivered",
    4: "Issue"
}

export default function Tracking_History(props) {

    const [tracks, setTracks] = useState([]);

    useEffect(() => {
        setTracks(props.history);
    }, [props.history, setTracks]);


    return (
        <MDBox pt={1} pb={2} px={2}>
            <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
                {tracks.map((item, ind) => (
                    <MDBox
                        component="li"
                        display="flex"
                        justifyContent="space-between"
                        alignItems="flex-start"
                        bgColor={"grey-100"}
                        borderRadius="lg"
                        p={2}
                        // mb={1}
                        mt={2}
                    >
                        <MDBox width="100%" display="flex" flexDirection="column">
                            <MDTypography variant="button" fontWeight="medium" textTransform="capitalize">
                                {item.date ? moment(item.date).format("Do MMM, hh:mm") : ""}
                            </MDTypography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DateTimePicker']}>
                                    <MobileDateTimePicker value={dayjs(item.date)} onChange={(newValue) => {
                                        console.log(event.target.value);
                                        let temp = [...tracks];
                                        temp[ind].date = newValue.toDate();
                                        setTracks([...temp]);
                                    }} />
                                </DemoContainer>
                            </LocalizationProvider>
                            <MDBox
                                display="flex"
                                justifyContent="space-between"
                                alignItems={{ xs: "flex-start", sm: "center" }}
                                flexDirection={{ xs: "column", sm: "row" }}
                                mt={2}
                            >

                                <MDBox display="flex" alignItems="center" mt={{ xs: 2, sm: 0 }} ml={{ xs: -1.5, sm: 0 }}>
                                    <MDBox mr={1}>
                                        <FormControl>
                                            <InputLabel id="demo-simple-select-label">Status</InputLabel>
                                            <Select
                                                // defaultValue=""
                                                // IconComponent={() => { return (<ArrowDropDown />) }}
                                                style={{ height: "1.4375em", padding: 20, marginRight: 10 }}
                                                onChange={(event) => {
                                                    console.log(event.target.value);
                                                    let temp = [...tracks];
                                                    temp[ind].status = event.target.value;
                                                    setTracks([...temp]);
                                                }}
                                                displayEmpty
                                                label={"Status"}
                                                value={item.status}
                                                inputProps={{ 'aria-label': 'Without label' }}
                                            >
                                                {Object.values(status_titles).map((item, ind) => (
                                                    <MenuItem value={item}>{item}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <MDInput label={"Message"} value={item.message} onChange={(event) => {
                                            console.log(event.target.value);
                                            let temp = [...tracks];
                                            temp[ind].message = event.target.value;
                                            setTracks([...temp]);
                                        }}></MDInput>
                                        {/* <MDTypography variant="button" fontWeight="medium" textTransform="capitalize">
                                            {"Test"}
                                        </MDTypography> */}
                                    </MDBox>
                                </MDBox>


                                <MDBox display="flex" alignItems="center" mt={{ xs: 2, sm: 0 }} ml={{ xs: -1.5, sm: 0 }}>
                                    <MDBox mr={1}>
                                        <MDButton variant="text" color="success" onClick={() => {
                                            // props.removeAttachment(ind);
                                            updateTrackingStatus(item._id, { status: item.status, message: item.message, date: item.date }).then((resp) => {
                                                console.log(resp);
                                                props.setShowDetails({ color: "success", icon: "", title: "Success", message: "Edited the history successfully", show: true });
                                            }).catch((err) => {
                                                console.log(err);
                                                props.setShowDetails({ color: "error", icon: "", title: "Failed", message: "Failed to edit the record", show: true });
                                            })
                                        }}>
                                            <Icon>check</Icon>
                                        </MDButton>
                                        <MDButton variant="text" color="error" onClick={() => {
                                            // props.removeAttachment(ind);
                                            deleteTrackingHistory(item._id).then((resp) => {
                                                console.log("Deleted the data", resp.data);
                                                let temp = [...tracks];
                                                temp.splice(ind, 1);
                                                setTracks([...temp]);
                                                props.setShowDetails({ color: "success", icon: "", title: "Success", message: "Deleted the history successfully", show: true });
                                            }).catch((err) => {
                                                props.setShowDetails({ color: "error", icon: "", title: "Failed", message: "Failed to delete the record", show: true });
                                                console.log(err);
                                            })
                                        }}>
                                            <Icon>delete</Icon>
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </MDBox>
                        </MDBox>
                    </MDBox>
                ))}

            </MDBox>
        </MDBox>
    );
}